jQuery(function() {
  lozad().observe();

  /* Moreview */
  $('.more-views .swiper-slide:first-child').addClass('active');
  $('.thumb-link').click(function() {
    $('.more-views .swiper-slide').removeClass('active');
    $(this).parent().addClass('active');
  });
  /* End Home Slider */
});

function aweMaps(mapElement) {
  if (! mapElement) {
    mapElement = '#contact-map';
  }

  var map = new GMaps({
    el: mapElement,
    lat: $(mapElement).data('lat'),
    lng: $(mapElement).data('lng'),

    draggable: true,
    scrollwheel: false
  });

  map.addMarker({
    lat: $(mapElement).data('lat'),
    lng: $(mapElement).data('lng'),
  });
}


/* Back to top */
$(window).scroll(function () {
  if ($(this).scrollTop() > 50) {
    $('.back-to-top').addClass('show');
  } else {
    $('.back-to-top').removeClass('show');
  }
});


$( window ).load(function() {
  /* Page loader */
  $( 'body' ).addClass( 'loaded' );
  setTimeout(function () {
    $('#pageloader').fadeOut();
  }, 500);
});

(function($) {
  "use strict";
  $(document).ready(function() {

    /* Back to top */
    $('.back-to-top').on( 'click', function(e) {
      e.preventDefault();
      $("html, body").animate({
        scrollTop: 0
      }, 500);
    });


    /* OWL carousel */
    $(".owl-carousel-play .owl-carousel").each( function(){
      var config = {
        loop: $(this).data('loop'),
        nav: $(this).data('nav'),
        navText: ["<i class='fal fa-chevron-left'></i>","<i class='fal fa-chevron-right'></i>"],
        margin: $(this).data('margin'),
        items: $(this).data('items'),
        lazyLoad : $(this).data('lazyLoad'),
        dots: $(this).data('dots'),
        autoHeight: $(this).data('autoHeight'),
        responsiveClass:true,
        responsive:{
          0:{
            items: 1,
            nav:true
          },
          480:{
            items:$(this).data('xs-items')
          },
          768:{
            items:$(this).data('sm-items')
          },
          981:{
            items:$(this).data('items')
          }

        }
      };
      $(this).owlCarousel( config );
    });

    /* Swiper */
    window.initSwiper = function(el, options) {
      var config = Object.assign({
        spaceBetween: $(el).data('margin') || 0,
        slidesPerView: $(el).data('items') || 1,
        direction: $(el).data('direction') || 'horizontal',
        paginationClickable: true,
        grabCursor: true,
        loop: !!$(el).data('loop'),
        lazy: !!$(el).data('lazy'),
        watchOverflow: true
      }, options || {});

      config.breakpoints = {
        0: {
          slidesPerView: 1
        },
        480: {
          slidesPerView: $(el).data('xs-items') || config.slidesPerView
        },
        768: {
          slidesPerView: $(el).data('sm-items') || config.slidesPerView
        },
        981: {
          slidesPerView: $(el).data('items') || config.slidesPerView
        }
      };

      if ($(el).data('autoplay')) {
        config.autoplay = { delay: 8000 };
      }

      if ($(el).find('.swiper-button-next').length > 0 && $(el).find('.swiper-button-prev').length > 0) {
        config.navigation = {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      } else if ($(el).data('nav-prev') && $(el).data('nav-next')) {
        config.navigation = {
          prevEl: $(el).data('nav-prev'),
          nextEl: $(el).data('nav-next')
        };
      }

      if ($(el).find('.swiper-pagination').length > 0) {
        config.pagination = {
          el: '.swiper-pagination',
          type: 'bullets'
        }
      }

      return new Swiper(el, config);
    }
    $(".swiper-container:not(.no-init)").each(function () {
      initSwiper(this);
    });

    /* Tabs */
    $(".e-tabs").each( function(){
      $(this).find('.tabs-title li:first-child').addClass('current');
      $(this).find('.tab-content').first().addClass('current');

      $(this).find('.tabs-title li').click(function(){
        var tab_id = $(this).attr('data-tab');

        var url = $(this).attr('data-url');
        $(this).closest('.e-tabs').find('.tab-viewall').attr('href',url);

        $(this).closest('.e-tabs').find('.tabs-title li').removeClass('current');
        $(this).closest('.e-tabs').find('.tab-content').removeClass('current');

        $(this).addClass('current');
        $(this).closest('.e-tabs').find("#"+tab_id).addClass('current');
      });

    });


    /* Countdown */
    $('.countdown ul').each( function(){
      var endDate = $(this).data( 'date' );
      $(this).countdown({
        date: endDate,
        render: function(data) {
          $(this.el).html(
            '<li><span>' + this.leadingZeros(data.days, 2) + '</span> Days</li>'
            + '<li><span>' + this.leadingZeros(data.hours, 2) + '</span>Hours</li>'
            + '<li><span>' + this.leadingZeros(data.min, 2) + '</span>Mins</li>'
            + '<li><span>' + this.leadingZeros(data.sec, 2) + '</span>Secs</li>'
          );
        }
      });
    });


    /* Burger Menu */
    $('.burger-control').on( 'click', function(e) {
      $( '#popup-burger' ).toggleClass('popup-open');
      $(this).toggleClass('active');
      e.preventDefault();
    });

    $( '.popup-close' ).on( 'click', function(e) {
      e.preventDefault();
      $( this ).parents( '.popup' ).removeClass( 'popup-open' );
    });

    /*  [ Mouse click scroll down ]         - - - - - - - - - - - - - - - - - - - - */
    $( '.mouse-scroll' ).on( 'click', function(e) {
      e.preventDefault();
      $("html, body").animate({
        scrollTop: $( window ).height()
      }, 700, function() {
        $('.sticky-wrapper').addClass('is-sticky');
      });
    });

    /* Tag */
    var minfontSize = 10;
    var maxfontSize = 24;

    $('.block-blog-tags').find('a').each(function(e){
      $(this).css("font-size", randumNumber(minfontSize, maxfontSize));
    });

    function randumNumber(min, max){
      return Math.floor(Math.random()*(max-min+1)+min);
    }

    // mobile sticky header
    var lastPos = window.scrollY;
    var $header = $('.header-wrap.sticky');
    $(window).on('scroll', function () {
      if (window.scrollY < lastPos && window.scrollY > 0) {
        $header.addClass('is-scrolling-up');
      } else {
        $header.removeClass('is-scrolling-up');
      }
      lastPos = window.scrollY;
    })
  });
})(jQuery);
